/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/~__root'
import { Route as LoginRouteImport } from './routes/~login'
import { Route as DashboardRouteImport } from './routes/~dashboard'
import { Route as IndexRouteImport } from './routes/~index'
import { Route as DashboardQuizRouteImport } from './routes/~dashboard/~quiz'
import { Route as DashboardProfileRouteImport } from './routes/~dashboard/~profile'
import { Route as DashboardPresentationRouteImport } from './routes/~dashboard/~presentation'
import { Route as DashboardOrganizationRouteImport } from './routes/~dashboard/~organization'
import { Route as DashboardMaterialRouteImport } from './routes/~dashboard/~material'
import { Route as DashboardIndexRouteImport } from './routes/~dashboard/~index'
import { Route as DashboardQuizNewRouteImport } from './routes/~dashboard/~quiz/~new'
import { Route as DashboardQuizIdRouteImport } from './routes/~dashboard/~quiz/~$id'
import { Route as DashboardPresentationNewRouteImport } from './routes/~dashboard/~presentation/~new'
import { Route as DashboardPresentationIdRouteImport } from './routes/~dashboard/~presentation/~$id'
import { Route as DashboardMaterialNewRouteImport } from './routes/~dashboard/~material/~new'
import { Route as DashboardMaterialIdRouteImport } from './routes/~dashboard/~material/~$id'
import { Route as DashboardEvaluateNewRouteImport } from './routes/~dashboard/~evaluate/~new'
import { Route as DashboardEvaluateIdRouteImport } from './routes/~dashboard/~evaluate/~$id'
import { Route as DashboardPresentationIndexRouteImport } from './routes/~dashboard/~presentation/~index'
import { Route as DashboardMaterialIndexRouteImport } from './routes/~dashboard/~material/~index'
import { Route as DashboardQuizNewIndexRouteImport } from './routes/~dashboard/~quiz/~new.index'
import { Route as DashboardQuizNewSelectSubjectRouteImport } from './routes/~dashboard/~quiz/~new.select-subject'
import { Route as DashboardPresentationNewSelectUnitRouteImport } from './routes/~dashboard/~presentation/~new.select-unit'
import { Route as DashboardPresentationNewSelectSubjectRouteImport } from './routes/~dashboard/~presentation/~new.select-subject'
import { Route as DashboardPresentationIdViewRouteImport } from './routes/~dashboard/~presentation/~$id.view'
import { Route as DashboardMaterialNewSelectUnitRouteImport } from './routes/~dashboard/~material/~new.select-unit'
import { Route as DashboardMaterialNewSelectSubjectRouteImport } from './routes/~dashboard/~material/~new.select-subject'
import { Route as DashboardEvaluateQuestionSetNewRouteImport } from './routes/~dashboard/~evaluate/~question-set/~new'
import { Route as DashboardEvaluateQuestionSetIdRouteImport } from './routes/~dashboard/~evaluate/~question-set/~$id'
import { Route as DashboardEvaluateAnswerScriptIdRouteImport } from './routes/~dashboard/~evaluate/~answer-script/~$id'

const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRoute = DashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardQuizRoute = DashboardQuizRouteImport.update({
  id: '/quiz',
  path: '/quiz',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardProfileRoute = DashboardProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPresentationRoute = DashboardPresentationRouteImport.update({
  id: '/presentation',
  path: '/presentation',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardOrganizationRoute = DashboardOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardMaterialRoute = DashboardMaterialRouteImport.update({
  id: '/material',
  path: '/material',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardIndexRoute = DashboardIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardQuizNewRoute = DashboardQuizNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DashboardQuizRoute,
} as any)
const DashboardQuizIdRoute = DashboardQuizIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardQuizRoute,
} as any)
const DashboardPresentationNewRoute =
  DashboardPresentationNewRouteImport.update({
    id: '/new',
    path: '/new',
    getParentRoute: () => DashboardPresentationRoute,
  } as any)
const DashboardPresentationIdRoute = DashboardPresentationIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardPresentationRoute,
} as any)
const DashboardMaterialNewRoute = DashboardMaterialNewRouteImport.update({
  id: '/new',
  path: '/new',
  getParentRoute: () => DashboardMaterialRoute,
} as any)
const DashboardMaterialIdRoute = DashboardMaterialIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => DashboardMaterialRoute,
} as any)
const DashboardEvaluateNewRoute = DashboardEvaluateNewRouteImport.update({
  id: '/evaluate/new',
  path: '/evaluate/new',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardEvaluateIdRoute = DashboardEvaluateIdRouteImport.update({
  id: '/evaluate/$id',
  path: '/evaluate/$id',
  getParentRoute: () => DashboardRoute,
} as any)
const DashboardPresentationIndexRoute =
  DashboardPresentationIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardPresentationRoute,
  } as any)
const DashboardMaterialIndexRoute = DashboardMaterialIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardMaterialRoute,
} as any)
const DashboardQuizNewIndexRoute = DashboardQuizNewIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardQuizNewRoute,
} as any)
const DashboardQuizNewSelectSubjectRoute =
  DashboardQuizNewSelectSubjectRouteImport.update({
    id: '/select-subject',
    path: '/select-subject',
    getParentRoute: () => DashboardQuizNewRoute,
  } as any)
const DashboardPresentationNewSelectUnitRoute =
  DashboardPresentationNewSelectUnitRouteImport.update({
    id: '/select-unit',
    path: '/select-unit',
    getParentRoute: () => DashboardPresentationNewRoute,
  } as any)
const DashboardPresentationNewSelectSubjectRoute =
  DashboardPresentationNewSelectSubjectRouteImport.update({
    id: '/select-subject',
    path: '/select-subject',
    getParentRoute: () => DashboardPresentationNewRoute,
  } as any)
const DashboardPresentationIdViewRoute =
  DashboardPresentationIdViewRouteImport.update({
    id: '/view',
    path: '/view',
    getParentRoute: () => DashboardPresentationIdRoute,
  } as any)
const DashboardMaterialNewSelectUnitRoute =
  DashboardMaterialNewSelectUnitRouteImport.update({
    id: '/select-unit',
    path: '/select-unit',
    getParentRoute: () => DashboardMaterialNewRoute,
  } as any)
const DashboardMaterialNewSelectSubjectRoute =
  DashboardMaterialNewSelectSubjectRouteImport.update({
    id: '/select-subject',
    path: '/select-subject',
    getParentRoute: () => DashboardMaterialNewRoute,
  } as any)
const DashboardEvaluateQuestionSetNewRoute =
  DashboardEvaluateQuestionSetNewRouteImport.update({
    id: '/evaluate/question-set/new',
    path: '/evaluate/question-set/new',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEvaluateQuestionSetIdRoute =
  DashboardEvaluateQuestionSetIdRouteImport.update({
    id: '/evaluate/question-set/$id',
    path: '/evaluate/question-set/$id',
    getParentRoute: () => DashboardRoute,
  } as any)
const DashboardEvaluateAnswerScriptIdRoute =
  DashboardEvaluateAnswerScriptIdRouteImport.update({
    id: '/evaluate/answer-script/$id',
    path: '/evaluate/answer-script/$id',
    getParentRoute: () => DashboardRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/material': typeof DashboardMaterialRouteWithChildren
  '/dashboard/organization': typeof DashboardOrganizationRoute
  '/dashboard/presentation': typeof DashboardPresentationRouteWithChildren
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/quiz': typeof DashboardQuizRouteWithChildren
  '/dashboard/material/': typeof DashboardMaterialIndexRoute
  '/dashboard/presentation/': typeof DashboardPresentationIndexRoute
  '/dashboard/evaluate/$id': typeof DashboardEvaluateIdRoute
  '/dashboard/evaluate/new': typeof DashboardEvaluateNewRoute
  '/dashboard/material/$id': typeof DashboardMaterialIdRoute
  '/dashboard/material/new': typeof DashboardMaterialNewRouteWithChildren
  '/dashboard/presentation/$id': typeof DashboardPresentationIdRouteWithChildren
  '/dashboard/presentation/new': typeof DashboardPresentationNewRouteWithChildren
  '/dashboard/quiz/$id': typeof DashboardQuizIdRoute
  '/dashboard/quiz/new': typeof DashboardQuizNewRouteWithChildren
  '/dashboard/evaluate/answer-script/$id': typeof DashboardEvaluateAnswerScriptIdRoute
  '/dashboard/evaluate/question-set/$id': typeof DashboardEvaluateQuestionSetIdRoute
  '/dashboard/evaluate/question-set/new': typeof DashboardEvaluateQuestionSetNewRoute
  '/dashboard/material/new/select-subject': typeof DashboardMaterialNewSelectSubjectRoute
  '/dashboard/material/new/select-unit': typeof DashboardMaterialNewSelectUnitRoute
  '/dashboard/presentation/$id/view': typeof DashboardPresentationIdViewRoute
  '/dashboard/presentation/new/select-subject': typeof DashboardPresentationNewSelectSubjectRoute
  '/dashboard/presentation/new/select-unit': typeof DashboardPresentationNewSelectUnitRoute
  '/dashboard/quiz/new/select-subject': typeof DashboardQuizNewSelectSubjectRoute
  '/dashboard/quiz/new/': typeof DashboardQuizNewIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/dashboard': typeof DashboardIndexRoute
  '/dashboard/organization': typeof DashboardOrganizationRoute
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/quiz': typeof DashboardQuizRouteWithChildren
  '/dashboard/material': typeof DashboardMaterialIndexRoute
  '/dashboard/presentation': typeof DashboardPresentationIndexRoute
  '/dashboard/evaluate/$id': typeof DashboardEvaluateIdRoute
  '/dashboard/evaluate/new': typeof DashboardEvaluateNewRoute
  '/dashboard/material/$id': typeof DashboardMaterialIdRoute
  '/dashboard/material/new': typeof DashboardMaterialNewRouteWithChildren
  '/dashboard/presentation/$id': typeof DashboardPresentationIdRouteWithChildren
  '/dashboard/presentation/new': typeof DashboardPresentationNewRouteWithChildren
  '/dashboard/quiz/$id': typeof DashboardQuizIdRoute
  '/dashboard/evaluate/answer-script/$id': typeof DashboardEvaluateAnswerScriptIdRoute
  '/dashboard/evaluate/question-set/$id': typeof DashboardEvaluateQuestionSetIdRoute
  '/dashboard/evaluate/question-set/new': typeof DashboardEvaluateQuestionSetNewRoute
  '/dashboard/material/new/select-subject': typeof DashboardMaterialNewSelectSubjectRoute
  '/dashboard/material/new/select-unit': typeof DashboardMaterialNewSelectUnitRoute
  '/dashboard/presentation/$id/view': typeof DashboardPresentationIdViewRoute
  '/dashboard/presentation/new/select-subject': typeof DashboardPresentationNewSelectSubjectRoute
  '/dashboard/presentation/new/select-unit': typeof DashboardPresentationNewSelectUnitRoute
  '/dashboard/quiz/new/select-subject': typeof DashboardQuizNewSelectSubjectRoute
  '/dashboard/quiz/new': typeof DashboardQuizNewIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/dashboard': typeof DashboardRouteWithChildren
  '/login': typeof LoginRoute
  '/dashboard/': typeof DashboardIndexRoute
  '/dashboard/material': typeof DashboardMaterialRouteWithChildren
  '/dashboard/organization': typeof DashboardOrganizationRoute
  '/dashboard/presentation': typeof DashboardPresentationRouteWithChildren
  '/dashboard/profile': typeof DashboardProfileRoute
  '/dashboard/quiz': typeof DashboardQuizRouteWithChildren
  '/dashboard/material/': typeof DashboardMaterialIndexRoute
  '/dashboard/presentation/': typeof DashboardPresentationIndexRoute
  '/dashboard/evaluate/$id': typeof DashboardEvaluateIdRoute
  '/dashboard/evaluate/new': typeof DashboardEvaluateNewRoute
  '/dashboard/material/$id': typeof DashboardMaterialIdRoute
  '/dashboard/material/new': typeof DashboardMaterialNewRouteWithChildren
  '/dashboard/presentation/$id': typeof DashboardPresentationIdRouteWithChildren
  '/dashboard/presentation/new': typeof DashboardPresentationNewRouteWithChildren
  '/dashboard/quiz/$id': typeof DashboardQuizIdRoute
  '/dashboard/quiz/new': typeof DashboardQuizNewRouteWithChildren
  '/dashboard/evaluate/answer-script/$id': typeof DashboardEvaluateAnswerScriptIdRoute
  '/dashboard/evaluate/question-set/$id': typeof DashboardEvaluateQuestionSetIdRoute
  '/dashboard/evaluate/question-set/new': typeof DashboardEvaluateQuestionSetNewRoute
  '/dashboard/material/new/select-subject': typeof DashboardMaterialNewSelectSubjectRoute
  '/dashboard/material/new/select-unit': typeof DashboardMaterialNewSelectUnitRoute
  '/dashboard/presentation/$id/view': typeof DashboardPresentationIdViewRoute
  '/dashboard/presentation/new/select-subject': typeof DashboardPresentationNewSelectSubjectRoute
  '/dashboard/presentation/new/select-unit': typeof DashboardPresentationNewSelectUnitRoute
  '/dashboard/quiz/new/select-subject': typeof DashboardQuizNewSelectSubjectRoute
  '/dashboard/quiz/new/': typeof DashboardQuizNewIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/'
    | '/dashboard/material'
    | '/dashboard/organization'
    | '/dashboard/presentation'
    | '/dashboard/profile'
    | '/dashboard/quiz'
    | '/dashboard/material/'
    | '/dashboard/presentation/'
    | '/dashboard/evaluate/$id'
    | '/dashboard/evaluate/new'
    | '/dashboard/material/$id'
    | '/dashboard/material/new'
    | '/dashboard/presentation/$id'
    | '/dashboard/presentation/new'
    | '/dashboard/quiz/$id'
    | '/dashboard/quiz/new'
    | '/dashboard/evaluate/answer-script/$id'
    | '/dashboard/evaluate/question-set/$id'
    | '/dashboard/evaluate/question-set/new'
    | '/dashboard/material/new/select-subject'
    | '/dashboard/material/new/select-unit'
    | '/dashboard/presentation/$id/view'
    | '/dashboard/presentation/new/select-subject'
    | '/dashboard/presentation/new/select-unit'
    | '/dashboard/quiz/new/select-subject'
    | '/dashboard/quiz/new/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/dashboard'
    | '/dashboard/organization'
    | '/dashboard/profile'
    | '/dashboard/quiz'
    | '/dashboard/material'
    | '/dashboard/presentation'
    | '/dashboard/evaluate/$id'
    | '/dashboard/evaluate/new'
    | '/dashboard/material/$id'
    | '/dashboard/material/new'
    | '/dashboard/presentation/$id'
    | '/dashboard/presentation/new'
    | '/dashboard/quiz/$id'
    | '/dashboard/evaluate/answer-script/$id'
    | '/dashboard/evaluate/question-set/$id'
    | '/dashboard/evaluate/question-set/new'
    | '/dashboard/material/new/select-subject'
    | '/dashboard/material/new/select-unit'
    | '/dashboard/presentation/$id/view'
    | '/dashboard/presentation/new/select-subject'
    | '/dashboard/presentation/new/select-unit'
    | '/dashboard/quiz/new/select-subject'
    | '/dashboard/quiz/new'
  id:
    | '__root__'
    | '/'
    | '/dashboard'
    | '/login'
    | '/dashboard/'
    | '/dashboard/material'
    | '/dashboard/organization'
    | '/dashboard/presentation'
    | '/dashboard/profile'
    | '/dashboard/quiz'
    | '/dashboard/material/'
    | '/dashboard/presentation/'
    | '/dashboard/evaluate/$id'
    | '/dashboard/evaluate/new'
    | '/dashboard/material/$id'
    | '/dashboard/material/new'
    | '/dashboard/presentation/$id'
    | '/dashboard/presentation/new'
    | '/dashboard/quiz/$id'
    | '/dashboard/quiz/new'
    | '/dashboard/evaluate/answer-script/$id'
    | '/dashboard/evaluate/question-set/$id'
    | '/dashboard/evaluate/question-set/new'
    | '/dashboard/material/new/select-subject'
    | '/dashboard/material/new/select-unit'
    | '/dashboard/presentation/$id/view'
    | '/dashboard/presentation/new/select-subject'
    | '/dashboard/presentation/new/select-unit'
    | '/dashboard/quiz/new/select-subject'
    | '/dashboard/quiz/new/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DashboardRoute: typeof DashboardRouteWithChildren
  LoginRoute: typeof LoginRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard/quiz': {
      id: '/dashboard/quiz'
      path: '/quiz'
      fullPath: '/dashboard/quiz'
      preLoaderRoute: typeof DashboardQuizRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/profile': {
      id: '/dashboard/profile'
      path: '/profile'
      fullPath: '/dashboard/profile'
      preLoaderRoute: typeof DashboardProfileRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/presentation': {
      id: '/dashboard/presentation'
      path: '/presentation'
      fullPath: '/dashboard/presentation'
      preLoaderRoute: typeof DashboardPresentationRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/organization': {
      id: '/dashboard/organization'
      path: '/organization'
      fullPath: '/dashboard/organization'
      preLoaderRoute: typeof DashboardOrganizationRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/material': {
      id: '/dashboard/material'
      path: '/material'
      fullPath: '/dashboard/material'
      preLoaderRoute: typeof DashboardMaterialRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/': {
      id: '/dashboard/'
      path: '/'
      fullPath: '/dashboard/'
      preLoaderRoute: typeof DashboardIndexRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/quiz/new': {
      id: '/dashboard/quiz/new'
      path: '/new'
      fullPath: '/dashboard/quiz/new'
      preLoaderRoute: typeof DashboardQuizNewRouteImport
      parentRoute: typeof DashboardQuizRoute
    }
    '/dashboard/quiz/$id': {
      id: '/dashboard/quiz/$id'
      path: '/$id'
      fullPath: '/dashboard/quiz/$id'
      preLoaderRoute: typeof DashboardQuizIdRouteImport
      parentRoute: typeof DashboardQuizRoute
    }
    '/dashboard/presentation/new': {
      id: '/dashboard/presentation/new'
      path: '/new'
      fullPath: '/dashboard/presentation/new'
      preLoaderRoute: typeof DashboardPresentationNewRouteImport
      parentRoute: typeof DashboardPresentationRoute
    }
    '/dashboard/presentation/$id': {
      id: '/dashboard/presentation/$id'
      path: '/$id'
      fullPath: '/dashboard/presentation/$id'
      preLoaderRoute: typeof DashboardPresentationIdRouteImport
      parentRoute: typeof DashboardPresentationRoute
    }
    '/dashboard/material/new': {
      id: '/dashboard/material/new'
      path: '/new'
      fullPath: '/dashboard/material/new'
      preLoaderRoute: typeof DashboardMaterialNewRouteImport
      parentRoute: typeof DashboardMaterialRoute
    }
    '/dashboard/material/$id': {
      id: '/dashboard/material/$id'
      path: '/$id'
      fullPath: '/dashboard/material/$id'
      preLoaderRoute: typeof DashboardMaterialIdRouteImport
      parentRoute: typeof DashboardMaterialRoute
    }
    '/dashboard/evaluate/new': {
      id: '/dashboard/evaluate/new'
      path: '/evaluate/new'
      fullPath: '/dashboard/evaluate/new'
      preLoaderRoute: typeof DashboardEvaluateNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/evaluate/$id': {
      id: '/dashboard/evaluate/$id'
      path: '/evaluate/$id'
      fullPath: '/dashboard/evaluate/$id'
      preLoaderRoute: typeof DashboardEvaluateIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/presentation/': {
      id: '/dashboard/presentation/'
      path: '/'
      fullPath: '/dashboard/presentation/'
      preLoaderRoute: typeof DashboardPresentationIndexRouteImport
      parentRoute: typeof DashboardPresentationRoute
    }
    '/dashboard/material/': {
      id: '/dashboard/material/'
      path: '/'
      fullPath: '/dashboard/material/'
      preLoaderRoute: typeof DashboardMaterialIndexRouteImport
      parentRoute: typeof DashboardMaterialRoute
    }
    '/dashboard/quiz/new/': {
      id: '/dashboard/quiz/new/'
      path: '/'
      fullPath: '/dashboard/quiz/new/'
      preLoaderRoute: typeof DashboardQuizNewIndexRouteImport
      parentRoute: typeof DashboardQuizNewRoute
    }
    '/dashboard/quiz/new/select-subject': {
      id: '/dashboard/quiz/new/select-subject'
      path: '/select-subject'
      fullPath: '/dashboard/quiz/new/select-subject'
      preLoaderRoute: typeof DashboardQuizNewSelectSubjectRouteImport
      parentRoute: typeof DashboardQuizNewRoute
    }
    '/dashboard/presentation/new/select-unit': {
      id: '/dashboard/presentation/new/select-unit'
      path: '/select-unit'
      fullPath: '/dashboard/presentation/new/select-unit'
      preLoaderRoute: typeof DashboardPresentationNewSelectUnitRouteImport
      parentRoute: typeof DashboardPresentationNewRoute
    }
    '/dashboard/presentation/new/select-subject': {
      id: '/dashboard/presentation/new/select-subject'
      path: '/select-subject'
      fullPath: '/dashboard/presentation/new/select-subject'
      preLoaderRoute: typeof DashboardPresentationNewSelectSubjectRouteImport
      parentRoute: typeof DashboardPresentationNewRoute
    }
    '/dashboard/presentation/$id/view': {
      id: '/dashboard/presentation/$id/view'
      path: '/view'
      fullPath: '/dashboard/presentation/$id/view'
      preLoaderRoute: typeof DashboardPresentationIdViewRouteImport
      parentRoute: typeof DashboardPresentationIdRoute
    }
    '/dashboard/material/new/select-unit': {
      id: '/dashboard/material/new/select-unit'
      path: '/select-unit'
      fullPath: '/dashboard/material/new/select-unit'
      preLoaderRoute: typeof DashboardMaterialNewSelectUnitRouteImport
      parentRoute: typeof DashboardMaterialNewRoute
    }
    '/dashboard/material/new/select-subject': {
      id: '/dashboard/material/new/select-subject'
      path: '/select-subject'
      fullPath: '/dashboard/material/new/select-subject'
      preLoaderRoute: typeof DashboardMaterialNewSelectSubjectRouteImport
      parentRoute: typeof DashboardMaterialNewRoute
    }
    '/dashboard/evaluate/question-set/new': {
      id: '/dashboard/evaluate/question-set/new'
      path: '/evaluate/question-set/new'
      fullPath: '/dashboard/evaluate/question-set/new'
      preLoaderRoute: typeof DashboardEvaluateQuestionSetNewRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/evaluate/question-set/$id': {
      id: '/dashboard/evaluate/question-set/$id'
      path: '/evaluate/question-set/$id'
      fullPath: '/dashboard/evaluate/question-set/$id'
      preLoaderRoute: typeof DashboardEvaluateQuestionSetIdRouteImport
      parentRoute: typeof DashboardRoute
    }
    '/dashboard/evaluate/answer-script/$id': {
      id: '/dashboard/evaluate/answer-script/$id'
      path: '/evaluate/answer-script/$id'
      fullPath: '/dashboard/evaluate/answer-script/$id'
      preLoaderRoute: typeof DashboardEvaluateAnswerScriptIdRouteImport
      parentRoute: typeof DashboardRoute
    }
  }
}

interface DashboardMaterialNewRouteChildren {
  DashboardMaterialNewSelectSubjectRoute: typeof DashboardMaterialNewSelectSubjectRoute
  DashboardMaterialNewSelectUnitRoute: typeof DashboardMaterialNewSelectUnitRoute
}

const DashboardMaterialNewRouteChildren: DashboardMaterialNewRouteChildren = {
  DashboardMaterialNewSelectSubjectRoute:
    DashboardMaterialNewSelectSubjectRoute,
  DashboardMaterialNewSelectUnitRoute: DashboardMaterialNewSelectUnitRoute,
}

const DashboardMaterialNewRouteWithChildren =
  DashboardMaterialNewRoute._addFileChildren(DashboardMaterialNewRouteChildren)

interface DashboardMaterialRouteChildren {
  DashboardMaterialIndexRoute: typeof DashboardMaterialIndexRoute
  DashboardMaterialIdRoute: typeof DashboardMaterialIdRoute
  DashboardMaterialNewRoute: typeof DashboardMaterialNewRouteWithChildren
}

const DashboardMaterialRouteChildren: DashboardMaterialRouteChildren = {
  DashboardMaterialIndexRoute: DashboardMaterialIndexRoute,
  DashboardMaterialIdRoute: DashboardMaterialIdRoute,
  DashboardMaterialNewRoute: DashboardMaterialNewRouteWithChildren,
}

const DashboardMaterialRouteWithChildren =
  DashboardMaterialRoute._addFileChildren(DashboardMaterialRouteChildren)

interface DashboardPresentationIdRouteChildren {
  DashboardPresentationIdViewRoute: typeof DashboardPresentationIdViewRoute
}

const DashboardPresentationIdRouteChildren: DashboardPresentationIdRouteChildren =
  {
    DashboardPresentationIdViewRoute: DashboardPresentationIdViewRoute,
  }

const DashboardPresentationIdRouteWithChildren =
  DashboardPresentationIdRoute._addFileChildren(
    DashboardPresentationIdRouteChildren,
  )

interface DashboardPresentationNewRouteChildren {
  DashboardPresentationNewSelectSubjectRoute: typeof DashboardPresentationNewSelectSubjectRoute
  DashboardPresentationNewSelectUnitRoute: typeof DashboardPresentationNewSelectUnitRoute
}

const DashboardPresentationNewRouteChildren: DashboardPresentationNewRouteChildren =
  {
    DashboardPresentationNewSelectSubjectRoute:
      DashboardPresentationNewSelectSubjectRoute,
    DashboardPresentationNewSelectUnitRoute:
      DashboardPresentationNewSelectUnitRoute,
  }

const DashboardPresentationNewRouteWithChildren =
  DashboardPresentationNewRoute._addFileChildren(
    DashboardPresentationNewRouteChildren,
  )

interface DashboardPresentationRouteChildren {
  DashboardPresentationIndexRoute: typeof DashboardPresentationIndexRoute
  DashboardPresentationIdRoute: typeof DashboardPresentationIdRouteWithChildren
  DashboardPresentationNewRoute: typeof DashboardPresentationNewRouteWithChildren
}

const DashboardPresentationRouteChildren: DashboardPresentationRouteChildren = {
  DashboardPresentationIndexRoute: DashboardPresentationIndexRoute,
  DashboardPresentationIdRoute: DashboardPresentationIdRouteWithChildren,
  DashboardPresentationNewRoute: DashboardPresentationNewRouteWithChildren,
}

const DashboardPresentationRouteWithChildren =
  DashboardPresentationRoute._addFileChildren(
    DashboardPresentationRouteChildren,
  )

interface DashboardQuizNewRouteChildren {
  DashboardQuizNewSelectSubjectRoute: typeof DashboardQuizNewSelectSubjectRoute
  DashboardQuizNewIndexRoute: typeof DashboardQuizNewIndexRoute
}

const DashboardQuizNewRouteChildren: DashboardQuizNewRouteChildren = {
  DashboardQuizNewSelectSubjectRoute: DashboardQuizNewSelectSubjectRoute,
  DashboardQuizNewIndexRoute: DashboardQuizNewIndexRoute,
}

const DashboardQuizNewRouteWithChildren =
  DashboardQuizNewRoute._addFileChildren(DashboardQuizNewRouteChildren)

interface DashboardQuizRouteChildren {
  DashboardQuizIdRoute: typeof DashboardQuizIdRoute
  DashboardQuizNewRoute: typeof DashboardQuizNewRouteWithChildren
}

const DashboardQuizRouteChildren: DashboardQuizRouteChildren = {
  DashboardQuizIdRoute: DashboardQuizIdRoute,
  DashboardQuizNewRoute: DashboardQuizNewRouteWithChildren,
}

const DashboardQuizRouteWithChildren = DashboardQuizRoute._addFileChildren(
  DashboardQuizRouteChildren,
)

interface DashboardRouteChildren {
  DashboardIndexRoute: typeof DashboardIndexRoute
  DashboardMaterialRoute: typeof DashboardMaterialRouteWithChildren
  DashboardOrganizationRoute: typeof DashboardOrganizationRoute
  DashboardPresentationRoute: typeof DashboardPresentationRouteWithChildren
  DashboardProfileRoute: typeof DashboardProfileRoute
  DashboardQuizRoute: typeof DashboardQuizRouteWithChildren
  DashboardEvaluateIdRoute: typeof DashboardEvaluateIdRoute
  DashboardEvaluateNewRoute: typeof DashboardEvaluateNewRoute
  DashboardEvaluateAnswerScriptIdRoute: typeof DashboardEvaluateAnswerScriptIdRoute
  DashboardEvaluateQuestionSetIdRoute: typeof DashboardEvaluateQuestionSetIdRoute
  DashboardEvaluateQuestionSetNewRoute: typeof DashboardEvaluateQuestionSetNewRoute
}

const DashboardRouteChildren: DashboardRouteChildren = {
  DashboardIndexRoute: DashboardIndexRoute,
  DashboardMaterialRoute: DashboardMaterialRouteWithChildren,
  DashboardOrganizationRoute: DashboardOrganizationRoute,
  DashboardPresentationRoute: DashboardPresentationRouteWithChildren,
  DashboardProfileRoute: DashboardProfileRoute,
  DashboardQuizRoute: DashboardQuizRouteWithChildren,
  DashboardEvaluateIdRoute: DashboardEvaluateIdRoute,
  DashboardEvaluateNewRoute: DashboardEvaluateNewRoute,
  DashboardEvaluateAnswerScriptIdRoute: DashboardEvaluateAnswerScriptIdRoute,
  DashboardEvaluateQuestionSetIdRoute: DashboardEvaluateQuestionSetIdRoute,
  DashboardEvaluateQuestionSetNewRoute: DashboardEvaluateQuestionSetNewRoute,
}

const DashboardRouteWithChildren = DashboardRoute._addFileChildren(
  DashboardRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DashboardRoute: DashboardRouteWithChildren,
  LoginRoute: LoginRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
